export default __webpack_public_path__ + "static/media/wanderingdisciple.510edc45.png";